// Libraries
import React, { useContext } from 'react';

// Services and Contexts
import LanguageContext from '../../../contexts/LanguageContext';
import RatingsContext from '../../../contexts/RatingsContext';

// Material-UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

export default function ProductRecommendation({ userRatings }) {
  const { translate, language } = useContext(LanguageContext);
  const { ratings } = useContext(RatingsContext);
  const rowLabels = ratings.byCategory.diagram.colLabels;

  const renderInformation = () => {
    return (
      <Box>
        <Typography variant="h6" paragraph>
          <strong>{translate('SCREEN_RESULTS_PRODUCT_RECOMMENDATION_TITLE')}</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          {translate('SCREEN_RESULTS_PRODUCT_RECOMMENDATION_DESCRIPTION')}
        </Typography>
      </Box>
    );
  };

  const renderHeader = () => {
    return (
      <TableRow>
        <TableCell>
          <Typography variant="body1">
            <strong>{translate('SCREEN_RESULTS_PRODUCT_RECOMMENDATION_CATEGORY')}</strong>
          </Typography>
        </TableCell>
        <TableCell>
          <Typography variant="body1">
            <strong>{translate('SCREEN_RESULTS_PRODUCT_RECOMMENDATION_PRODUCT')}</strong>
          </Typography>
        </TableCell>
      </TableRow>
    );
  };

  const renderRows = () => {
    if (userRatings)
      return userRatings.map((userRating, index) => {
        if (userRating > 0) {
          const categoryName = rowLabels[index][language];
          const productName = ratings.byCategory.levels[index].product[userRating][language];
          return (
            <TableRow key={index}>
              <TableCell>
                <Typography variant="body1">{categoryName}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body1">{productName}</Typography>
              </TableCell>
            </TableRow>
          );
        }
        return null;
      });
  };

  return (
    <Box textAlign="left" px={4}>
      {renderInformation()}
      <Box mt={4} mb={6}>
        <TableContainer>
          <Table>
            <TableHead>{renderHeader()}</TableHead>
            <TableBody>{renderRows()}</TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}
